import { render, staticRenderFns } from "./StockProductSidebar.vue?vue&type=template&id=203faef6&"
import script from "./StockProductSidebar.vue?vue&type=script&lang=js&"
export * from "./StockProductSidebar.vue?vue&type=script&lang=js&"
import style0 from "./StockProductSidebar.vue?vue&type=style&index=0&id=203faef6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports